// Core features needed in all subsites
import './modules/core';

/* ========================================================================
 * Vuosikatsaus specific scripts (legacy stuff)
 * https://www.palmia.fi/fi/yritys/vuosikatsaus/
 * MAKE MODULES IF YOU DO ANYTHING NEW
 * ======================================================================== */

import $ from 'jquery';

$(function() {

  var $sections = $('h2');
  var $mainNav = $('ul.navigation');
  var $timelineItems = $('.timeline .items .item');

  $sections.each(function(i, section) {
    if($(section).attr('data-slug')) {
      $mainNav.append('<li><a href="#' + $(section).attr('data-slug') + '">' + $(section).html() + '</a></li>');
    }
  });

  var lastMonth = '';

  $timelineItems.each(function(i, item) {

    var $month = $(item).find('.month');

    // if we have a new month, show the ball and label
    if($month.attr('data-month') !== lastMonth) {
      lastMonth = $month.attr('data-month');
      $month.show();
    }

    $(item).addClass('loaded');
  });

});
